export default class InitManager {
  static createInitialCheckoutOverlayState() {
    return {
      data: {
        promoCodeNoCompleteUsed: [],
        remainPrice: 0,
        cartTotal: 0,
        payments: [],
        customer: null,
        establishment: null,
        cartItems: [],
        prepaidPrestations: [],
        customDiscount: 0,
        promoCodes: [],
        tmpPromoCodes: [],
        order: null,
        remainBeforeGlobalPromoCode: 0,
        remainAfterGlobalPromoCode: 0,
        voucherUsed: []
      },
    }
  }
}
